const API = {
  root: "/api/v1",
  image: "/image",
  pdf: "/pdf",
  quote: "/quote",
}

const getDataAssetsUrl = () => {
  return process.env.REACT_APP_DATA_ASSETS_URL || ""
}

const getDataConfigsUrl = () => {
  return process.env.REACT_APP_DATA_CONFIGS_URL || ""
}

const getCmsAssetsUrl = () => {
  return process.env.REACT_APP_CMS_ASSETS_URL || ""
}

const getApiEndpointUrl = (endpoint = "") => {
  if (!endpoint || !(endpoint in API)) {
    return ""
  }

  return `${API.root}${API[endpoint]}`
}

const getBackendBaseUrl = () => {
  const raw = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "")
  if (raw.startsWith("/")) {
    return `${window.location.origin}${raw}`
  }
  return raw
}

const getContactUsEndpoint = () => {
  return `${getBackendBaseUrl()}/api/contact`
}

const getRequestPdfEndpoint = () => {
  return `${getBackendBaseUrl()}/api/request`
}

const getLambdaUrl = () => {
  return process.env.REACT_APP_LAMBDA_URL || ""
}

const getSiteTitle = (viewer = false) => {
  if (viewer) {
    return process.env.REACT_APP_VIEWER_TITLE || "Ingeteam EVViewer"
  }

  return process.env.REACT_APP_SITE_TITLE || "Ingeteam EV"
}

const getCacheBustVersion = () => {
  return process.env.REACT_APP_CACHE_BUST || ""
}

const getCacheBustVersionParam = () => {
  const cacheBustVersion = getCacheBustVersion()

  return cacheBustVersion ? `?v=${cacheBustVersion}` : ""
}

const getEnabledLanguages = locales => {
  if (!locales || Object.entries(locales).length <= 0) {
    return null
  }

  const enabled = Object.entries(locales).filter(locale => {
    const [, localeData] = locale

    return localeData.enabled
  })

  if (!enabled || enabled.length <= 0) {
    return null
  }

  return Object.fromEntries(enabled)
}

const getSortedLanguages = locales => {
  if (!locales || Object.entries(locales).length <= 0) {
    return null
  }

  const sorted = Object.entries(locales).sort((a, b) => {
    const [, dataA] = a
    const [, dataB] = b

    const nameA = dataA.nativeName.toLowerCase()
    const nameB = dataB.nativeName.toLowerCase()

    if (nameA < nameB) {
      return -1
    }

    if (nameA > nameB) {
      return 1
    }

    return 0
  })

  if (!sorted || sorted.length <= 0) {
    return null
  }

  return Object.fromEntries(sorted)
}

const getDefaultLanguage = locales => {
  if (!locales || Object.entries(locales).length <= 0) {
    return null
  }

  const enabledLanguages = getEnabledLanguages(locales)

  const found = Object.entries(enabledLanguages).find(locale => {
    const [, localeData] = locale

    return localeData.default
  })

  if (!found || found.length <= 0) {
    return null
  }

  return found[0]
}

const stripHtml = (html = "") => {
  let tmp = document.createElement("DIV")
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ""
}

const str2bool = (value = "yes") => {
  if (value && typeof value === "string") {
    if (value.toLowerCase() === "yes") {
      return true
    }
    if (value.toLowerCase() === "no") {
      return false
    }
  }
  return value
}

const isInList = (list = [], value = "") => {
  if (!list || list.length <= 0 || !value) {
    return false
  }

  const lowerCaseList = list.map(i => i.toLowerCase())
  const lowerCaseValue = value.toLowerCase()

  return lowerCaseList.includes(lowerCaseValue)
}

const getWantedSite = () => {
  //Search subpath - strip PUBLIC_URL prefix so routing works from subdirectories
  const basePath = (process.env.PUBLIC_URL || "").replace(/\/+$/, "")
  let location = window.location.pathname
  if (basePath && location.startsWith(basePath)) {
    location = location.slice(basePath.length) || "/"
  }
  const regexSite = /^\/(?:[a-z]{2}\/)?([^/]+)/i
  const regexLanguage = /^\/[a-z]{2}(?=\/|$)/i

  const matchSite = location.match(regexSite)
  const matchLanguage = location.match(regexLanguage)

  //Get wanted site code from url
  let wantedSite = matchSite && matchSite[1] ? matchSite[1] : ""
  //Check if language path exists
  let redirect = false

  //If wanted site is not ingeteamev and missing language path redirect to site home with language
  if (wantedSite !== "" && !matchLanguage) {
    redirect = true
  }

  return { wantedSite, redirect }
}

export {
  getDataAssetsUrl,
  getDataConfigsUrl,
  getCmsAssetsUrl,
  getApiEndpointUrl,
  getContactUsEndpoint,
  getRequestPdfEndpoint,
  getLambdaUrl,
  getSiteTitle,
  getCacheBustVersion,
  getCacheBustVersionParam,
  getEnabledLanguages,
  getSortedLanguages,
  getDefaultLanguage,
  stripHtml,
  str2bool,
  isInList,
  getWantedSite,
}
